import { collectData } from '@caresource/watchtower-js'

export const getCollectedMeta = () => collectData()
